// LogoSplash.js
import React from 'react';
import './LogoSplash.css'; 
import Logo from './Home/Images/Logo.png'

const LogoSplash = () => {
  return (
   <div className="logo-splash">
  <img src={Logo} alt="Company Logo" className="logo" style={{ width: '400px', height: '320px' }} />
</div>
  );
};

export default LogoSplash;